import { Company } from '__models__/gql/company';

const companyDummy: Company = {
  averageHiringProcess: {
    companyAvg: '2-3 weeks',
    marketAvg: '4-6 weeks',
  },
  city: 'Nelas',
  companySize: {
    id: '5',
    label: '201 to 500',
  },
  countryCode: 'PT',
  countryName: 'Portugal',
  description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  glassdoorUrl: 'https://www.glassdoor.com/Overview/Working-FooCorp.htm',
  id: '1',
  industry: {
    id: '14',
    name: 'Technology',
  },
  logoUrl: 'https://foocorp.com/logo.png',
  name: 'FooCorp',
  rating: 4.1,
  slug: 'foocorp',
  shortPitch: 'We develop software. You pay',
  websiteUrl: 'https://foocorp.com/',
  coverPhotoUrl: '',
  numbers: [],
  perks: [],
};

export default companyDummy;
